export default "__VITE_PUBLIC_ASSET__f203ffc1__"